module.exports = __webpack_public_path__ + "img/y-h.49bb4bcc.png";